import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const OrgContextHubPage = lazy(() =>
  import('../pages/org-context/HubPage').then((m) => ({ default: m.HubPage }))
)
const StrategicGoalsPage = lazy(() =>
  import('../pages/org-context/StrategicGoalsPage').then((m) => ({ default: m.StrategicGoalsPage }))
)
const AlignmentPage = lazy(() =>
  import('../pages/org-context/AlignmentPage').then((m) => ({ default: m.AlignmentPage }))
)
const ConstraintsPage = lazy(() =>
  import('../pages/org-context/ConstraintsPage').then((m) => ({ default: m.ConstraintsPage }))
)

export const orgContextRoutes: RouteObject[] = [
  {
    path: 'org-context',
    children: [
      { index: true, element: <OrgContextHubPage /> },
      { path: 'hub', element: <OrgContextHubPage /> },
      { path: 'strategic-goals', element: <StrategicGoalsPage /> },
      { path: 'alignment', element: <AlignmentPage /> },
      { path: 'constraints', element: <ConstraintsPage /> },
    ],
  },
]
